import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import Marquee from "react-fast-marquee";
import { Button } from "../components/ui/button";
import { PARTNER_BRANDS, PARTNER_TYPED } from "../data/content";
import DemoDialog from "../sections/DemoDialog";

export default function CtaStrip() {
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <>
      <section
        data-testid="cta-strip"
        className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5 overflow-hidden"
      >
        <div className="absolute inset-0 -z-10 bg-radial-fade" />
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-4">
                / Let's Talk
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-slate-50 leading-tight">
                Ready to design your{" "}
                <span className="text-cyan-400">security architecture?</span>
              </h2>
              <p className="mt-5 max-w-2xl text-base md:text-lg text-slate-400 leading-relaxed">
                Book a 30-minute walkthrough — we'll review your facility, threat
                model and existing systems, then come back with a phased proposal
                within a business day.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3">
              <Button
                data-testid="cta-demo-btn"
                onClick={() => setDemoOpen(true)}
                className="bg-cyan-400 text-slate-950 hover:bg-cyan-300 rounded-none font-semibold h-12 btn-glow group"
              >
                Request a Demo
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Link to="/contact">
                <Button
                  variant="outline"
                  className="w-full bg-transparent border border-white/15 text-slate-100 hover:bg-white/5 hover:text-cyan-300 hover:border-cyan-400/40 rounded-none h-12"
                >
                  Contact Sales
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        data-testid="partners-strip"
        className="relative py-16 px-0 border-t border-white/5 bg-slate-950"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 mb-8">
          <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono">
            / Trusted Brands We Integrate
          </div>
        </div>
        <div className="border-y border-white/5 py-8">
          <Marquee gradient={false} speed={32} pauseOnHover>
            {PARTNER_BRANDS.map((b) => (
              <div key={b.name} className="mx-10 md:mx-14 flex items-center" title={b.name}>
                <img
                  src={b.logo}
                  alt={b.name}
                  className="partner-logo h-8 md:h-10 w-auto max-w-[140px] object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </Marquee>
        </div>
        <div className="border-b border-white/5 py-8">
          <Marquee gradient={false} speed={26} direction="right" pauseOnHover>
            {PARTNER_TYPED.map((name) => (
              <div
                key={name}
                className="mx-8 md:mx-12 text-2xl md:text-3xl font-medium tracking-tight text-slate-600 hover:text-cyan-300 transition-colors"
              >
                {name}
              </div>
            ))}
          </Marquee>
        </div>
      </section>
      <DemoDialog open={demoOpen} onOpenChange={setDemoOpen} />
    </>
  );
}
